"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Box_1 = __importDefault(require("@mui/material/Box"));
const Divider_1 = __importDefault(require("@mui/material/Divider"));
const Drawer_1 = __importDefault(require("@mui/material/Drawer"));
const React = __importStar(require("react"));
const List_1 = __importDefault(require("@mui/material/List"));
const Clear_1 = __importDefault(require("@mui/icons-material/Clear"));
const react_1 = require("react");
const MobileMenuItem_1 = __importDefault(require("./MobileMenuItem"));
const MobileTheme_1 = __importDefault(require("./MobileTheme"));
const themes_1 = require("../../../themes");
const MobileMenu = ({ isDrawerOpen, toggleDrawer, menuElements, mobileAccountLinks, isLoggedIn, buttonsSettings, themeVariant, }) => {
    const th = (0, MobileTheme_1.default)(themeVariant);
    const [openedItemIndex, setOpenedItemIndex] = (0, react_1.useState)(null);
    const loggedOutAccountLinks = [
        {
            label: buttonsSettings.loginButtonName,
            url: buttonsSettings.loginLink,
            onClick: buttonsSettings.onLoginClick,
            externalUrl: buttonsSettings.loginExternal,
            index: 0,
        },
        {
            label: buttonsSettings.registerButtonName,
            url: buttonsSettings.registerLink,
            onClick: buttonsSettings.onRegisterClick,
            externalUrl: buttonsSettings.registerExternal,
            index: 1,
        },
    ];
    const accountLinks = isLoggedIn ? mobileAccountLinks : loggedOutAccountLinks;
    const list = () => (React.createElement(Box_1.default, { sx: {
            width: '100%',
            color: th.text,
            fontSize: 'bold',
        }, role: "presentation" },
        React.createElement(Box_1.default, { sx: { display: 'flex', justifyContent: 'flex-end' } },
            React.createElement(Clear_1.default, { sx: {
                    marginTop: themes_1.Spacings.small4,
                    marginRight: themes_1.Spacings.small4,
                    width: 25,
                    height: 25,
                }, onClick: toggleDrawer })),
        isLoggedIn && (React.createElement(React.Fragment, null,
            React.createElement(List_1.default, { sx: { marginTop: themes_1.Spacings.small4 } }, menuElements.map((menuElem, i) => (React.createElement(MobileMenuItem_1.default, { key: menuElem.label, linkConfig: menuElem, toggleDrawer: toggleDrawer, isBottomMenu: false, onClick: () => setOpenedItemIndex(openedItemIndex === i ? null : i), isOpen: i === openedItemIndex, themeVariant: themeVariant })))),
            React.createElement(Divider_1.default, { sx: {
                    backgroundColor: th.divider,
                    borderColor: th.divider,
                    marginTop: themes_1.Spacings.small4,
                    marginBottom: themes_1.Spacings.small4,
                } }))),
        React.createElement(List_1.default, null, accountLinks.map((menuElem) => (React.createElement(MobileMenuItem_1.default, { key: menuElem.label, linkConfig: menuElem, onClick: menuElem.onClick, toggleDrawer: toggleDrawer, isBottomMenu: true, isOpen: false, themeVariant: themeVariant, isAccountLink: true }))))));
    return (React.createElement(React.Fragment, null,
        React.createElement(Drawer_1.default, { sx: {
                '& .full-screen-drawer': {
                    width: '100%',
                    backgroundColor: th.backgroundColor,
                },
            }, anchor: "left", open: isDrawerOpen, onClose: toggleDrawer, classes: {
                paper: 'full-screen-drawer',
            } }, list()),
        React.createElement(Divider_1.default, null)));
};
exports.default = MobileMenu;
